const customProps = {
  sideNavWidth: 80,
  bottomTabHeight: 35,
};

export default customProps;
